import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOCREATEORLINKACCOUNTMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoCreateOrLinkAccountModalDescriptor: _generatedComoCreateOrLinkAccountModalDescriptor,
  comoCreateOrLinkAccountModalModalDefinition,
  comoCreateOrLinkAccountModalDashboardLayout,
  comoCreateOrLinkAccountModalConfig,
  comoCreateOrLinkAccountModalResolveConfig,
  comoCreateOrLinkAccountModalProperties,
} = doodModalConfig(
  {
    name: "Como - Create or link account modal",
    handle: "como-create-or-link-account-modal",
    internal_name: "ComoCreateOrLinkAccountModal",
    componentType: 'ComoCreateOrLinkAccountModalComponent',
    category: 'modal',
    description: "Como - Create or link account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-create-or-link-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function comoCreateOrLinkAccountModalDescriptor(): IBlockDescriptor;
export function comoCreateOrLinkAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoCreateOrLinkAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoCreateOrLinkAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoCreateOrLinkAccountModalDescriptor, comoCreateOrLinkAccountModalProperties, fieldOrder);
}

export {
  comoCreateOrLinkAccountModalModalDefinition,
  comoCreateOrLinkAccountModalDashboardLayout,
  comoCreateOrLinkAccountModalProperties,
  comoCreateOrLinkAccountModalConfig,
  comoCreateOrLinkAccountModalResolveConfig,
};

export type ComoCreateOrLinkAccountModalConfig = typeof comoCreateOrLinkAccountModalConfig;
